import { z } from "zod";
import { BillingInvoiceProductItemSchema } from "./billing-invoice-product-item";
import { BillingOrderItemSchema } from "./billing-order-item";
import { DateValidation } from "../shared/date-validation";

export const BillingInvoiceItemSchema = z.object({
  Id: z.string(),
  AccountId: z.string().optional(),
  DiscountPercentage: z.number().optional(),
  EmailAddress: z.string().optional(),
  Number: z.string().optional(),
  ShippingMethodCode: z.number().optional(),
  ShipToCity: z.string().optional(),
  ShipTo: z.string().optional(),
  ShipToCountry: z.string().optional(),
  ShipToLine1: z.string().optional(),
  ShipToLine2: z.string().optional(),
  ShipToPostalCode: z.string().optional(),
  ShipToStateOrProvince: z.string().optional(),
  BillToCity: z.string().optional(),
  BillTo: z.string().optional(),
  BillToCountry: z.string().optional(),
  BillToLine1: z.string().optional(),
  BillToLine2: z.string().optional(),
  BillToPostalCode: z.string().optional(),
  BillToStateOrProvince: z.string().optional(),
  FreightAmount: z.number().optional(),
  FreightAmountTotalTax: z.number().optional(),
  AmountDue: z.number().optional(),
  DiscountAmount: z.number().optional(),
  TotalAmountInternal: z.number().optional(),
  TotalAmountLessFreight: z.number().optional(),
  TotalDiscountAmount: z.number().optional(),
  TotalLineItemAmount: z.number().optional(),
  TotalLineItemDiscountAmount: z.number().optional(),
  TotalAmount: z.number().optional(),
  TotalDetailAmount: z.number().optional(),
  TotalPreFreightAmount: z.number().optional(),
  TotalTax: z.number().optional(),
  Date: DateValidation,
  DueDate: DateValidation,
  Created: DateValidation,
  DateDelivered: DateValidation,
  SalesOrder: BillingOrderItemSchema.optional(),
  Items: BillingInvoiceProductItemSchema.array().optional(),
});

export type BillingInvoiceItemType = z.infer<typeof BillingInvoiceItemSchema>;
